import classNames from "classnames";
import classes from "./FccIntroTooltip.module.less";
import { IMG_FCC_INTRO_1, IMG_FCC_INTRO_2, IMG_FCC_INTRO_3, IMG_FCC_INTRO_4 } from "~/utils/url/staticResources";
import { Carousel2 } from "~/common/components/carousel/Carousel2";
import { Stack, Typography } from "~/common/mui";
import { useTranslation } from "react-i18next";

interface Props {
  className?: string;
}

const data = [
  {
    title: "fcc.intro.1.title",
    img: IMG_FCC_INTRO_1,
    text: "fcc.intro.1.text",
  },
  {
    title: "fcc.intro.2.title",
    img: IMG_FCC_INTRO_2,
    text: "fcc.intro.2.text",
  },
  {
    title: "fcc.intro.3.title",
    img: IMG_FCC_INTRO_3,
    text: "fcc.intro.3.text",
  },
  {
    title: "fcc.intro.4.title",
    img: IMG_FCC_INTRO_4,
    text: "fcc.intro.4.text",
  },
];

export const FccIntroTooltip = (props: Props) => {
  const { t } = useTranslation();
  return (
    <div className={classNames(classes.root, props.className)}>
      <Carousel2>
        {data.map((slide, index) => (
          <Stack key={index} className={classes.slide} gap={3}>
            <Typography variant={"titleMedium"}>
              <b>{t(slide.title)}</b>
            </Typography>
            <img src={slide.img} alt="" className={classes.image} />
            <Typography>{t(slide.text)}</Typography>
          </Stack>
        ))}
      </Carousel2>
    </div>
  );
};
